export const KITS_STATES = ["Prélevé", "Déposé au laboratoire", "Réceptionné"];
